import type { AtsOfferLetterTemplateFormSalaryFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface SalaryWarningParams {
  value: string | undefined
  touched: boolean
  jobPostingSalary: AtsOfferLetterTemplateFormSalaryFragment | null
}

export const getSalaryWarningStatus = ({
  value,
  touched,
  jobPostingSalary,
}: SalaryWarningParams) => {
  if (!touched) return undefined

  const numValue = parseFloat(value ?? '')
  if (isNaN(numValue)) return undefined

  if (!jobPostingSalary) return undefined

  const salaryFrom = jobPostingSalary.salaryFromAmountInCents
  const salaryTo = jobPostingSalary.salaryToAmountInCents
  const isFixed = jobPostingSalary.salaryFormat === 'fixed_amount'

  if (salaryFrom == null) return undefined

  const salaryFromInUnits = salaryFrom / 100
  const salaryToInUnits = salaryTo != null ? salaryTo / 100 : salaryFromInUnits

  const lowerBound = salaryFromInUnits * 0.8
  const upperBound = isFixed ? salaryFromInUnits * 1.2 : salaryToInUnits * 1.2

  if (numValue < lowerBound) {
    return {
      type: 'warning' as const,
      message: i18n.t('ats.send_offer_letter_modal.from_template.salary_warning_low'),
    }
  }

  if (numValue > upperBound) {
    return {
      type: 'warning' as const,
      message: i18n.t('ats.send_offer_letter_modal.from_template.salary_warning_high'),
    }
  }

  return undefined
}
